import { IContractPaymentsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisContractPaymentsRepository from './implementations/VectisContractPaymentsRepository';

let instance: IContractPaymentsRepository | null = null;

export default function makeContractPaymentsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisContractPaymentsRepository(httpProvider);
  }

  return instance;
}
